import { ExtractArrayType } from '@prophecy/interfaces/generic';
import { AllTeamsQuery } from '@prophecy/queries/pages/Metadata/components/Teams/api';
import { ResultOf } from 'gql.tada';

export { AllTeamsQuery };

type ResolveAspect<S extends Record<string, unknown>, K extends readonly string[], T extends readonly unknown[]> = {
  [P in keyof S]: P extends K[number] ? T[number] | null : S[P];
};

type TeamEntry = ExtractArrayType<NonNullable<ResultOf<typeof AllTeamsQuery>['User']>['teams']>;
export const teamAspectKeys = ['InfoAspect'] as const;
export type TeamWithAspects = ResolveAspect<TeamEntry, typeof teamAspectKeys, [{ description: string }]>;
